module.exports = __webpack_public_path__ + "static/media/favicon-32.8ea2d1e8.png";